/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { StoreState } from '../../structureDefinitions/storeState';
import type {
    SelectHomeDeliveryStorePayload,
    SelectPickupStorePayload,
    SyncStorePayload,
} from './storeActions';

import persistance from '../../../persistance/persistance';
import { DeliveryMode } from '../../structureDefinitions/storeState';
import { selectHomeDeliveryStore, selectPickupStore, syncStore } from './storeActions';
import { getStoreContextFromState } from './storeActions.utils';

// lets to check if cookie is ok here as well
const getInitialState = (): StoreState => {
    const storeContext = persistance.storeContext.get();
    const validState = getStoreContextFromState(storeContext);
    return {
        deliveryMode: validState.deliveryMode,
        pickupPointId: validState.pickupPointId,
        productionUnitId: validState.productionUnitId,
        storeName: validState.storeName,
        selectedStore: undefined,
    } as StoreState;
};

const slice = createSlice({
    name: 'store',
    initialState: getInitialState(),
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            selectPickupStore,
            (state: StoreState, action: PayloadAction<SelectPickupStorePayload>) => {
                state.deliveryMode = DeliveryMode.pickup;
                state.selectedStore = action.payload.store;
                state.pickupPointId = action.payload.pickupPointId;
                state.productionUnitId = action.payload.store.productionUnitIdentifier;
                state.storeName = action.payload.store.name;
            },
        );
        builder.addCase(
            selectHomeDeliveryStore,
            (state: StoreState, action: PayloadAction<SelectHomeDeliveryStorePayload>) => {
                state.deliveryMode = DeliveryMode.homedelivery;
                state.selectedStore = action.payload.store;
                state.pickupPointId = undefined;
                state.productionUnitId = action.payload.store.productionUnitIdentifier;
                state.storeName = action.payload.store.name || undefined;
            },
        );
        /** Sync with direct hybris calls */
        builder.addCase(syncStore, (state: StoreState, action: PayloadAction<SyncStorePayload>) => {
            state.deliveryMode = action.payload.deliveryMode;
            state.pickupPointId = action.payload.pickupPointId;
            state.productionUnitId = action.payload.productionUnitId;
            state.storeName = action.payload.storeName;
        });
    },
});

export const storeActions = {
    ...slice.actions,
    selectPickupStore,
    selectHomeDeliveryStore,
    syncStore,
};

export default slice.reducer;
